import { stateMapperArgsSelectors } from '#packages/stateManagement';

const {
  rootSels: { editorAPISel, getStateMapperArgsFromEditorAPI },
  mouseSels: { isDraggingSel },
  selectedCompsSels: { selectedCompsSel },
  selector: { createSelector, createStructuredSelector },
} = stateMapperArgsSelectors;

const layoutPropsSel = createStructuredSelector({
  isDragging: isDraggingSel,
  selectedComp: selectedCompsSel,
});

const shouldShowDeprecationOverlaySel = createSelector(
  [editorAPISel],
  (editorAPI) => {
    return (
      !editorAPI.isMobileEditor() &&
      !editorAPI.zoomMode.isInZoomMode() &&
      !editorAPI.pages.loading.getIsLoading()
    );
  },
);

export {
  getStateMapperArgsFromEditorAPI,
  shouldShowDeprecationOverlaySel,
  layoutPropsSel,
  isDraggingSel,
  selectedCompsSel,
};
